import { cn } from '@/lib/cn';

/** 符合最終布局的骨架，不使用全域圓形 spinner（spec 23.2）。 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'motion-safe:animate-pulse rounded-[var(--radius-control-lg)] bg-surface-sunken',
        className,
      )}
    />
  );
}

export function PageSkeleton() {
  return (
    <output className="block space-y-6" aria-label="載入中">
      <Skeleton className="h-8 w-52" />
      <div className="grid gap-4">
        <Skeleton className="h-28 w-full" />
        <Skeleton className="h-28 w-full" />
        <Skeleton className="h-28 w-3/4" />
      </div>
    </output>
  );
}
